import * as React from "react";
import { Helmet } from "react-helmet";
import { PriceCalculatorFormFetcher } from "@/features/price-calculator/PriceCalculatorFormFetcher";
import { PriceCalculatorProvider } from "@/features/price-calculator/PriceCalculatorContext";
import { stenaCalculate } from "@stenajs-webui/elements";
import { PageHeader } from "@/components/page-header/PageHeader";

interface Props {}

export const PriceCalculatorScreen: React.FC<Props> = () => {
  return (
    <>
      <Helmet title="Price Calculator - FPP" />
      <PageHeader title={"Price Calculator"} icon={stenaCalculate} />
      <PriceCalculatorProvider>
        <PriceCalculatorFormFetcher />
      </PriceCalculatorProvider>
    </>
  );
};
